import { render, staticRenderFns } from "./PantauTB.vue?vue&type=template&id=45664805"
import script from "./PantauTB.vue?vue&type=script&lang=js"
export * from "./PantauTB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports